<div *ngFor="let searchType of searchTypes">
    <sphere-search-type [searchType]="searchType" [searchText]="searchText"></sphere-search-type>
</div>
